import Bookmark from "../../../../../../shared/components/Bookmark/Bookmark";
import LanguageToggle from "../../../../../../shared/components/LanguageToggle/LanguageToggle";
import useAppHooks from "../../../../../../shared/hooks/useAppHooks";
import images from "../../../../../../utilities/images/images";
import "./QuestionHeader.css";

import { useDispatch } from "react-redux";
import { saveBookmarkRequest } from "../../../../../../redux/exam/examSlice";
import { updateQuestionStatus } from "../../../../../../redux/exam/examSlice";


const QuestionHeader = () => {
  const { selector } = useAppHooks();
  const dispatch = useDispatch();

  const { currentQuestionIndex, questionsData, bookmarks, loading } = selector(
    (state) => state.examSlice
  );

  const currentQuestion = questionsData?.[currentQuestionIndex];
const questionNumber = currentQuestionIndex + 1;

  // let sectionQuestionNumber = 1;

  // if (currentQuestion && questionsData?.length) {
  //   const currentSectionKey = `${currentQuestion.subject} ${
  //     currentQuestion.section_name || ""
  //   }`.trim();

  //   const sectionQuestions = questionsData.filter((q) => {
  //     const key = `${q.subject} ${q.section_name || ""}`.trim();
  //     return key === currentSectionKey;
  //   });

  //   const indexInSection = sectionQuestions.findIndex(
  //     (q) => q.qid === currentQuestion.qid
  //   );

  //   sectionQuestionNumber = indexInSection + 1;
  // }

  // const isBookmarked = bookmarks.some(
  //   (bookmark) => bookmark.reference_id === currentQuestion?.qid
  // );
const isBookmarked = currentQuestion?.marked === true;

//  const handleBookmarkClick = () => {
//     if (!currentQuestion) return;
//     dispatch(
//       saveBookmarkRequest({
//         type: 1,
//         status: isBookmarked ? 0 : 1,
//         reference_id: currentQuestion.qid,
//       })
//     );
//   };

  const handleBookmarkClick = () => {
  if (!currentQuestion) return;
  dispatch(
    updateQuestionStatus({
      qid: currentQuestion.qid,
      markReview: !isBookmarked, // 🔁 toggle
    })
  );
};


  return (
    <div className="integration-container">
      <div className="integration-left">
        {/* <span className="question-label">Q. {sectionQuestionNumber}</span> */}
          <span className="question-label">Q. {questionNumber}</span>
        <span className="question-divider"> | </span>
        <span className="question-type">
          {currentQuestion?.answer_type || "—"}
        </span>
      </div>

      <div className="integration-right">
        <Bookmark
          bookmarked={isBookmarked}
          loading={false}
          onClick={handleBookmarkClick}
          defaultImage={images.user_activity_bookmark_off}
          activeImage={images.user_activity_bookmark_on}
        />

        <LanguageToggle />
      </div>
    </div>
  );
};

export default QuestionHeader;
